/** Admin subscriptions/rewards hub for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import SubscriptionsScreen from '../../../../owner/subscriptions/index';

export default function AdminOwnerSubscriptionsScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <SubscriptionsScreen />
    </OwnerScopeProvider>
  );
}
